<div class="usecase-card" [class.usecase-card--list-view]="showShortDescription" (click)="onCardClick()">
  <!-- Card Content -->
  <div class="usecase-card__content">
    <!-- Row 1 list view: Label (title) left | Like View right. Grid: title only -->
    <div class="usecase-card__header-row">
      <div class="usecase-card__title-row">
        <h3 class="usecase-card__title">{{ card.title }}</h3>
        <!-- Bookmark Badge (same as dataset card) -->
        <div class="usecase-card__bookmark" *ngIf="isLoggedIn && isBookmarked">
          <svg class="usecase-card__bookmark-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" fill="#059669" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <!-- List view: activity to the right of label -->
      <div class="usecase-card__header-metrics" *ngIf="showShortDescription && showActivityMetrics && card.metrics">
        <div class="usecase-card__metric-item"
             [class.active]="isLiked"
             [class.clickable]="isLoggedIn"
             (click)="onLikeIconClick($event)"
             *ngIf="card.metrics.likes !== undefined">
          <svg class="usecase-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                  [attr.fill]="isLiked ? '#059669' : 'none'"
                  stroke="#059669"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
          <span class="usecase-card__metric-value">{{ card.metrics.likes }}</span>
        </div>
        <div class="usecase-card__metric-item" *ngIf="card.metrics.views !== undefined">
          <svg class="usecase-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="usecase-card__metric-value">{{ card.metrics.views | number }}</span>
        </div>
      </div>
    </div>

    <!-- Description -->
    <p class="usecase-card__description">{{ card.description }}</p>

    <!-- Tags and arrow: list view = same row (tags left, arrow right); grid = tags only -->
    <div class="usecase-card__tags-row" [class.usecase-card__tags-row--list]="showShortDescription">
      <div class="usecase-card__tags">
        <span 
          *ngFor="let tag of card.tags" 
          class="usecase-card__tag"
        >
          {{ tag }}
        </span>
      </div>
      <button class="usecase-card__arrow" *ngIf="showShortDescription" aria-label="View details" (click)="onCardClick(); $event.stopPropagation()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Footer: Like View (left) | Arrow (right) - grid view only -->
  <div class="usecase-card__footer" *ngIf="!showShortDescription">
    <div class="usecase-card__footer-metrics" *ngIf="showActivityMetrics && card.metrics">
      <div class="usecase-card__metric-item"
           [class.active]="isLiked"
           [class.clickable]="isLoggedIn"
           (click)="onLikeIconClick($event)"
           *ngIf="card.metrics.likes !== undefined">
        <svg class="usecase-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                [attr.fill]="isLiked ? '#059669' : 'none'"
                stroke="#059669"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
        <span class="usecase-card__metric-value">{{ card.metrics.likes }}</span>
      </div>
      <div class="usecase-card__metric-item" *ngIf="card.metrics.views !== undefined">
        <svg class="usecase-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="usecase-card__metric-value">{{ card.metrics.views | number }}</span>
      </div>
    </div>
    <button class="usecase-card__arrow" aria-label="View details" (click)="onCardClick(); $event.stopPropagation()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
